<template>
  <div class="recover-password">
    <v-col cols="10" md="6" sm="12" class="mt-1 mx-auto">
      <v-col cols="12" md="12" sm="12" class="pb-4 mt-n5">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          width="400"
          class="mx-auto"
        />
      </v-col>

      <div class="mt-3">
        <v-stepper dark v-model="e1" class="stepper-card">
          <v-stepper-header>
            <v-stepper-step class="body-2" :complete="e1 > 1" step="1">
              Enter your Registerd Email
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step class="body-2" :complete="e1 > 2" step="2">
              Fill out Details
            </v-stepper-step>

            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <!--//* stepper 1 content -->
            <v-stepper-content step="1">
              <v-card class="mb-12" light height="100px">
                <v-col cols="12" md="8" sm="8" class="ma-auto py-5">
                  <v-text-field
                    class="input"
                    v-model.trim="form.email"
                    :rules="emailRules"
                    label="E-mail*"
                    outlined
                    filled
                    required
                    prepend-inner-icon="mdi-email-variant"
                  ></v-text-field
                ></v-col>
              </v-card>

              <v-btn text color="#65C599" @click="sendOtp"> Continue </v-btn>
            </v-stepper-content>
            <!--//* stepper 1 content ends -->

            <!--//* stepper 2 content -->
            <v-stepper-content step="2">
              <v-card class="mb-12" light>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent="resetPassword"
                >
                  <v-col cols="12" md="8" sm="8" class="ma-auto">
                    <v-text-field
                      class="input"
                      v-model.trim="form.email"
                      :rules="emailRules"
                      label="E-mail*"
                      outlined
                      filled
                      required
                      prepend-inner-icon="mdi-email-variant"
                    ></v-text-field
                  ></v-col>

                  <!-- //* New password -->
                  <div align="center" class="mt-n8">
                    <v-col cols="12" md="8" sm="12">
                      <v-text-field
                        class="input"
                        v-model="form.NewPassword"
                        :rules="passwordRules"
                        label="New Password*"
                        :type="showNewpassword ? 'text' : 'password'"
                        :append-icon="
                          showNewpassword ? 'mdi-eye' : 'mdi-eye-off'
                        "
                        @click:append="showNewpassword = !showNewpassword"
                        outlined
                        filled
                        required
                        prepend-inner-icon="mdi-form-textbox-password"
                      ></v-text-field
                    ></v-col>
                  </div>

                  <!-- //* confirm new password -->
                  <div align="center" class="mt-n8">
                    <v-col cols="12" md="8" sm="12">
                      <v-text-field
                        class="input"
                        v-model="form.ConfirmPassword"
                        :rules="[passwordConfirmationRule]"
                        label="Confirm New Password*"
                        :type="showNewpassword ? 'text' : 'password'"
                        outlined
                        filled
                        required
                        prepend-inner-icon="mdi-form-textbox-password"
                      ></v-text-field
                    ></v-col>
                  </div>

                  <div align="center" class="mt-n8">
                    <v-col cols="12" md="8" sm="12">
                      <v-text-field
                        class="input"
                        label="OTP*"
                        v-model="form.Otp"
                        outlined
                        filled
                        required
                        prepend-inner-icon="mdi-key-star"
                      ></v-text-field
                    ></v-col>
                  </div>
                </v-form>
              </v-card>

              <v-btn text color="#65C599" @click="resetPassword">
                Submit
              </v-btn>

              <v-btn color="info" @click="e1 = 1">Back</v-btn>
            </v-stepper-content>
            <!--//* stepper 2 content ends -->
          </v-stepper-items>
        </v-stepper>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "RecoverPasswordWOtp",
  data() {
    return {
      valid: true,
      e1: 1,
      showPassword: false,
      showNewpassword: false,
      form: {
        email: "",
        password: "",
        NewPassword: "",
        ConfirmPassword: "",
        Otp: "",
      },
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      passwordRules: [
        (v) =>
          (v && /^[a-z0-9\-]+$/.test(v)) ||
          `Only lowercase letters, numbers or hyphens allowed`,
        (v) => v.length >= 6 || "Min 6 characters",
      ],
    };
  },

  computed: {
    ...mapState("NbaModule", ["otp", "verification"]),

    passwordConfirmationRule() {
      return () =>
        this.form.NewPassword === this.form.ConfirmPassword ||
        "Password must match";
    },
  },

  methods: {
    sendOtp() {
      this.$store
        .dispatch("NbaModule/forgetPassword", { email: this.form.email })
        .then(() => {
          if (this.otp.success) {
            //console.log(this.otp.response.otp);
            this.e1 = 2;
          } else return;
        });
    },

    resetPassword() {
      this.$refs.form.validate();

      if (this.$refs.form.validate()) {
        let obj = {
          email: this.form.email,
          password: this.form.NewPassword,
          confirmPassword: this.form.ConfirmPassword,
          otp: this.form.Otp,
        };
        this.$store.dispatch("NbaModule/verifyOTP", obj).then(() => {
          if (this.verification.success) {
            this.$router.push({ name: "loginForm" });
          } else return;
        });
      }
    },
  },
};
</script>

<style scoped>
.recover-password {
  background-color: #212121;
  min-height: 100vh;
}

.input >>> input {
  color: rgba(0, 0, 0, 0.87);
  margin-top: 0px;
}

.stepper-card {
  transition: all 0.3s ease-in-out 0s;
  border-radius: 20px;
}

.stepper-card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 8px 8px 0px rgba(170, 170, 170, 0.15);
}
</style>
